import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { toast } from 'react-toastify';

import { BackButtonPage } from "components/__new/common/BackButton";
import DynamicHeadTag from "components/__new/common/DynamicHeadTag";
import { ReactComponent as IconUpload } from "assets/images/icons/project-icons/upload.svg";
import { ButtonLoader } from "components/__new/common/form";
import useBackButton from "hooks/useBackButton";
import validate from "utils/validate";
import BulkUpload from "components/__new/employees/BulkUpload";
import CreateEditForm from "components/__new/employees/CreateEditForm";
import * as employeesActions from "store/entities/employees/action";
import * as infoActions from "store/entities/settingsInfo/action";
import * as banksActions from "store/ui/banks/action";
import * as groupsActions from "store/entities/groups/action";
import * as payrollSetupActions from "store/entities/payroll/payrollSetup/action";
import ModalAlert from "components/__new/common/ModalAlert";
import useLoginInfo from 'hooks/useLoginInfo';
import useBanks from 'hooks/useBanks';


const Form = () => {
    // const history = useHistory();
    const dispatch = useDispatch();
    const {goBack} = useBackButton();
    const {userInfo} = useLoginInfo();
    const { employeeCreateLoading, employeeCreateSuccess, employeeCreateStatus } = useSelector((s) => s.entities.employees);
    // const { companyInfoLoading, companyInfo } = useSelector((s) => s.entities.settingsInfo);
    const { banks, banksLoading } = useBanks(userInfo?.token);
    const { getAllGroupsLoading: groupsLoading, allGroups: groups } = useSelector((s) => s.entities.groups);
    const { pensionProvidersLoading, pensionProvidersData } = useSelector((s) => s.entities.payrollSetup);

    
    // const [isCompanyInfoFilled, setIsCompanyInfoFilled] = useState(null);
    const [isOpenModalAlert, setIsOpenModalAlert] = useState(false);
    const [isOpenBulkUpload, setIsOpenBulkUpload] = useState(false);
    const [form, setForm] = useState({
        firstName: "",
        lastName: "",
        email: "",
        phoneNumber: "",
        jobTitle: "",
        staffId: "",
        groupPolicyId: "general-group",
        netMonthlySalary: "",
        grossAnnualPay: "",
        bankName: "",
        bankCode: "",
        bankAccountNumber: "",
        taxIdentificationNumber: "",
        pensionAdministrator: "",
        pensionNumber: "",
        pensionAdministratorCode: "",
    })


    const getBankName = () => {
        const bankData = banks;
        for (var i = 0; i < bankData?.length; i++){
            if (bankData[i].code === form.bankCode){
                return (bankData[i].name);
            }
        }
        return null;
    }


    const getPfaCode = () => {
        const selectedAdministrator = pensionProvidersData?.data?.find((item) => item?.name === form?.pensionAdministrator);
        if(selectedAdministrator) {
            return selectedAdministrator?.pfa_code;
        }
    }


    const submitForm = async e => {
        e.preventDefault();
        const validateForm = {...form};
        delete validateForm["resumedAt"];
        delete validateForm["pensionAdministrator"];
        delete validateForm["pensionNumber"];
        delete validateForm["taxIdentificationNumber"];
        delete validateForm["pensionAdministratorCode"];
        delete validateForm["staffId"];
        delete validateForm["grossAnnualPay"];
        const errors = validate(validateForm);
        if (errors){
            for (var x in errors) {
                toast.error(errors[x]);
            };
            return;
        }
        else{
            const bankName = getBankName();
            const pensionAdministratorCode = getPfaCode();
            const params = {...form, bankName, pensionAdministratorCode};
            setForm(params);
            dispatch(employeesActions.createEmployee(params));
        }
    }


    const resetForm = () => {
        setForm({
            firstName: "",
            lastName: "",
            email: "",
            phoneNumber: "",
            jobTitle: "",
            staffId: "",
            groupPolicyId: "general-group",
            netMonthlySalary: "",
            grossAnnualPay: "",
            bankName: "",
            bankCode: "",
            bankAccountNumber: "",
            taxIdentificationNumber: "",
            pensionAdministrator: "",
            pensionNumber: "",
            pensionAdministratorCode: "",
        })
    }


    useEffect(() => {
        dispatch(infoActions.getInfo(userInfo?.company?.selectedCompanyId));
        dispatch(banksActions.getAllBanks());
        dispatch(groupsActions.getAllGroups());
        dispatch(payrollSetupActions.getPensionProviders());
        // eslint-disable-next-line
    }, [])


    /*
    useEffect(() => {
        if (companyInfo?.status === "success"){
            const companyInfoFilled = checkCompanyInfo(companyInfo, "existing employer");
            setIsCompanyInfoFilled(companyInfoFilled);
        }
        // eslint-disable-next-line
    }, [companyInfo]);
    */
    

    useEffect(() => {
        if (employeeCreateSuccess === true){
            dispatch(employeesActions.resetEmployeeCreateSuccess());
            if (!employeeCreateStatus?.jobId){
                // history.push("/employees");
                setIsOpenModalAlert(true);
                resetForm();
            }
        }
        // eslint-disable-next-line
    }, [employeeCreateSuccess]);
    

    return ( 
        <div>


            <DynamicHeadTag
                headerText="Add Employees"
                headerDescription="Manage and monitor your employees' payment activity."
            />
            

            <ModalAlert
                successText="Employee added successfully"
                dismissText="Add Another Employee"
                isOpenModalAlert={isOpenModalAlert}
                setIsOpenModalAlert={setIsOpenModalAlert}
            />


            <div className="lg:flex">
                <div className="w-full lg:w-1/2">
                    <div className="page-title flex">
                        <BackButtonPage />
                        Add Employee
                    </div>
                </div>
                <div className="w-full lg:w-1/2 flex mt-4 lg:mt-0 lg:justify-end space-x-3">
                    <button type="button" onClick={() => setIsOpenBulkUpload(true)} className="flex items-center text-ep-primary underline cursor-pointer">
                        <IconUpload className="h-4 mr-2" />
                        Switch to bulk upload
                    </button>
                </div>
            </div>


            <BulkUpload
                isOpen={isOpenBulkUpload}
                setIsOpen={setIsOpenBulkUpload}
            />


            {/* 
            <PageContent
                loading={companyInfoLoading}
                data={companyInfo}
                loadingText="Checking company information..."
                emptyText="Company information not found"
                errorText="Unable to fetch company information"
            />

            <Maybe condition={companyInfoLoading === false && companyInfo?.status === "success"}>
                <Maybe condition={isCompanyInfoFilled === false}>
                    <div className="table-info-full-page">
                        <div className="table-info">
                            <FontAwesomeIcon icon="exclamation-triangle" className="text-red-700" style={{"fontSize":"4.5rem"}} />
                            <div className="mt-4">
                                Your company information has not been filled yet.
                                <br />
                                Please fill your company information before adding your employees.
                            </div>
                            <div className="mt-4">
                                <Link to="/settings/info" className="btn btn-md btn-ep-primary mx-auto">
                                    Goto Company Info
                                </Link>
                            </div>
                        </div>
                    </div>
                </Maybe>
                
                <Maybe condition={isCompanyInfoFilled === true}>
                     */}
                     
                    <div className="mt-6 box">
                        <div className="max-w-2xl">
                            <form onSubmit={submitForm}>

                                <CreateEditForm
                                    form={form}
                                    setForm={setForm}
                                    groupsLoading={groupsLoading}
                                    groups={groups}
                                    banksLoading={banksLoading}
                                    banks={banks}
                                    pensionProvidersLoading={pensionProvidersLoading}
                                    pensionProvidersData={pensionProvidersData}
                                />

                                <div className="mt-4 flex space-x-4">
                                    <ButtonLoader type="submit" loading={employeeCreateLoading} className="btn btn-ep-primary">
                                        Add Employee
                                    </ButtonLoader>
                                    <button type="button" onClick={goBack} className="btn btn-transparent-primary">
                                        Cancel
                                    </button>
                                </div>
                                
                            </form>
                        </div>
                    </div>

                    {/* 
                </Maybe>
            </Maybe>
             */}


        </div>
    )
}


export default Form;